import * as React from 'react';
import styled from 'styled-components';
class Button extends React.Component {
    render() {
        return (React.createElement(StyledButton, { onClick: () => { this.props.clicked(); } },
            React.createElement(StyledSpan, null, this.props.label)));
    }
}
;
export default Button;
const StyledButton = styled.div `
  border: 1px solid #666;
  color: white;
  cursor: pointer;
  display: inline-block;
  margin: 10px 10px 10px 0;
  padding: 3px;

  &:hover {
    border-color: #fff;
  }

  &:active {
    border-color: #555;
  }

  &:active span {
    background-color: #555;
  }
`;
const StyledSpan = styled.span `
  background-color: rgba(0, 0, 0, 0.85);
  display: inline-block;
  padding: 5px;
`;
//# sourceMappingURL=Button.js.map


// WEBPACK FOOTER //
// ./src/components/Button.js